import React from 'react';
import cx from 'classnames';
import { string } from 'prop-types';
import segmentStatus from 'propTypes/segmentStatus';
import SegmentSmallIcon from 'icons/segment-small.inline.svg';
import SegmentSmallBrokenIcon from 'icons/segment-small-broken.inline.svg';

import styles from './segment-name-display.scss';

export default function SegmentNameDisplay({
  segmentName,
  fromLocationName,
  toLocationName,
  status,
  className,
}) {
  const isReporting = status !== 'disconnected';

  return (
    <div className={cx(styles.main, className)}>
      {isReporting
        ? <SegmentSmallIcon width={8} className={styles.segmentIcon} />
        : <SegmentSmallBrokenIcon width={8} className={styles.segmentIcon} />}
      <div className={styles.segmentName}>
        <div>
          {segmentName || fromLocationName}
        </div>
        <div>
          {segmentName ? '' : toLocationName}
        </div>
      </div>
    </div>
  );
}

SegmentNameDisplay.propTypes = {
  segmentName: string,
  fromLocationName: string,
  toLocationName: string,
  status: segmentStatus.isRequired,
  className: string,
};



// WEBPACK FOOTER //
// ./src/components/SegmentNameDisplay/index.js